"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsWidgetTypeEnum = void 0;
var StatsWidgetTypeEnum;
(function (StatsWidgetTypeEnum) {
    StatsWidgetTypeEnum["Table"] = "table";
    StatsWidgetTypeEnum["Grid"] = "grid";
    StatsWidgetTypeEnum["Bar"] = "bar";
    StatsWidgetTypeEnum["Line"] = "line";
    StatsWidgetTypeEnum["Text"] = "text";
    StatsWidgetTypeEnum["Pie"] = "pie";
    StatsWidgetTypeEnum["Radar"] = "radar";
    StatsWidgetTypeEnum["Polar"] = "polar";
    StatsWidgetTypeEnum["Timeline"] = "timeline";
})(StatsWidgetTypeEnum = exports.StatsWidgetTypeEnum || (exports.StatsWidgetTypeEnum = {}));
